import React, { useEffect, useState } from "react";
import axios from "axios";
import Input from "../../CoreComponent/Input";
import ImageUpload from "../../CoreComponent/ImageUpload";
import DateInput from "../../CoreComponent/Date";
import "./style.scss";
import TextArea from "../../CoreComponent/TextArea";
import SVG from "react-inlinesvg";
import deleteIcon from "../../icons/deleteIcon.svg";
import toast from "react-hot-toast";
import { Box, Button, Drawer, IconButton, Typography } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";

// Custom Select Component
const Select = ({ label, options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (optionValue) => {
    if (typeof onChange === "function") onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div style={{ marginBottom: "16px", position: "relative", overflow: "visible" }}>
      <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#333" }}>
        {label}
      </label>

      <div
        style={{
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          backgroundColor: "#fff",
          fontSize: "14px",
          color: "#333",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {value || "Select Country"}
      </div>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "4px",
            maxHeight: "200px",
            overflowY: "scroll",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              style={{
                padding: "10px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                backgroundColor: value === option.value ? "#f0f0f0" : "transparent",
              }}
            >
              <img
                src={option.flag_url}
                alt={option.label}
                style={{ width: "20px", marginRight: "8px" }}
              />
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

/* ✅ COMPLETE PriceForm */
const PriceForm = ({ entries, setEntries }) => {
  const addEntry = () => {
    setEntries([
      ...entries,
      {
        id: Date.now(),
        price_type: "",
        price: "",
        description: "",
        whats_include: [{ id: Date.now() + 1, text: "" }],
      },
    ]);
  };

  const deleteEntry = (id) => setEntries(entries.filter((entry) => entry.id !== id));

  const handleInputChange = (id, key, value) => {
    const updatedEntries = entries.map((entry) => (entry.id === id ? { ...entry, [key]: value } : entry));
    setEntries(updatedEntries);
  };

  const addWhatsInclude = (entryId) => {
    const updatedEntries = entries.map((entry) =>
      entry.id === entryId
        ? {
            ...entry,
            whats_include: [
              ...(Array.isArray(entry.whats_include) ? entry.whats_include : []),
              { id: Date.now(), text: "" },
            ],
          }
        : entry
    );
    setEntries(updatedEntries);
  };

  const deleteWhatsInclude = (entryId, includeId) => {
    const updatedEntries = entries.map((entry) =>
      entry.id === entryId
        ? {
            ...entry,
            whats_include: Array.isArray(entry.whats_include)
              ? entry.whats_include.filter((item) => item.id !== includeId)
              : [],
          }
        : entry
    );
    setEntries(updatedEntries);
  };

  const handleWhatsIncludeChange = (entryId, includeId, value) => {
    const updatedEntries = entries.map((entry) =>
      entry.id === entryId
        ? {
            ...entry,
            whats_include: Array.isArray(entry.whats_include)
              ? entry.whats_include.map((item) => (item.id === includeId ? { ...item, text: value } : item))
              : [{ id: includeId, text: value }],
          }
        : entry
    );
    setEntries(updatedEntries);
  };

  return (
    <div className="price-form-container">
      <div className="price-header">Pricing Information</div>

      <div className="button-section-container">
        <Button className="add-button-pricing" onClick={addEntry}>
          Add Entry
        </Button>
      </div>

      {entries.map((entry) => (
        <div key={entry.id} className="entry-row">
          <Input
            label="Price Type"
            placeholder="Enter Price Type"
            inputValue={entry.price_type || ""}
            setInputValue={(value) => handleInputChange(entry.id, "price_type", value)}
            type="text"
          />

          <Input
            label="Price (USD)"
            placeholder="Enter Price"
            inputValue={entry.price || ""}
            setInputValue={(value) => handleInputChange(entry.id, "price", value)}
            type="number"
          />

          <div className="whats-included-section" style={{ margin: "20px 0" }}>
            <div style={{ fontWeight: "bold", marginBottom: "12px", fontSize: "16px" }}>
              What's included
            </div>

            <div className="whats-include-items">
              {Array.isArray(entry.whats_include) && entry.whats_include.length > 0 ? (
                entry.whats_include.map((includeItem) => (
                  <div
                    key={includeItem.id}
                    className="whats-include-row"
                    style={{ display: "flex", gap: "10px", alignItems: "end", marginBottom: "8px" }}
                  >
                    <Input
                      placeholder="Enter what's included"
                      inputValue={includeItem.text || ""}
                      setInputValue={(value) => handleWhatsIncludeChange(entry.id, includeItem.id, value)}
                      type="text"
                      style={{ flex: 1 }}
                    />

                    <Button
                      className="delete-whats-include"
                      onClick={() => deleteWhatsInclude(entry.id, includeItem.id)}
                      size="small"
                      variant="outlined"
                      style={{ minWidth: "80px" }}
                    >
                      Delete
                    </Button>
                  </div>
                ))
              ) : (
                <p style={{ color: "#888", fontStyle: "italic", margin: "8px 0" }}>
                  No items added yet
                </p>
              )}

              <Button
                className="add-whats-include"
                onClick={() => addWhatsInclude(entry.id)}
                size="small"
                variant="outlined"
                style={{ marginTop: "8px" }}
              >
                + Add More
              </Button>
            </div>
          </div>

          <Input
            label="Description"
            placeholder="Enter Description"
            inputValue={entry.description || ""}
            setInputValue={(value) => handleInputChange(entry.id, "description", value)}
            type="text"
          />

          <Button className="delete-button-entry" onClick={() => deleteEntry(entry.id)}>
            Delete Entry
          </Button>
        </div>
      ))}
    </div>
  );
};

/* ✅ CommitteeForm (delete + updates) */
const CommitteeForm = ({
  committeeMembers,
  setCommitteeMembers,
  countriesList = [],
  onDeleteExistingId,
}) => {
  const generateId = () => Math.random().toString(36).substr(2, 9);

  const addCommitteeMember = () => {
    setCommitteeMembers([
      ...committeeMembers,
      {
        id: generateId(), // local id for new members
        backend_id: null, // actual DB id (null => create)
        name: "",
        title: "",
        committee_type: "",
        country: "",
        conference_id: "",
        image: null,
      },
    ]);
  };

  const deleteCommitteeMember = (member) => {
    if (member?.backend_id && typeof onDeleteExistingId === "function") {
      onDeleteExistingId(member.backend_id);
    }
    setCommitteeMembers(committeeMembers.filter((m) => m.id !== member.id));
  };

  const handleInputChange = (id, field, value) => {
    const updatedMembers = committeeMembers.map((member) =>
      member.id === id ? { ...member, [field]: value } : member
    );
    setCommitteeMembers(updatedMembers);
  };

  return (
    <div className="committee-form-container">
      <div className="title-committee">Committee Members</div>

      <div className="button-section-container">
        <Button className="add-button-committee" onClick={addCommitteeMember}>
          Add Member
        </Button>
      </div>

      {committeeMembers.map((member) => (
        <div key={member.id} className="committee-member">
          <div className="member-info">
            <Input
              type="text"
              label="Name"
              placeholder="Enter name"
              inputValue={member.name || ""}
              setInputValue={(value) => handleInputChange(member.id, "name", value)}
              className="name-input"
            />

            <Input
              type="text"
              label="Title"
              placeholder="Enter title"
              inputValue={member.title || ""}
              setInputValue={(value) => handleInputChange(member.id, "title", value)}
              className="title-input"
            />

            <Input
              type="text"
              label="Committee Type"
              placeholder="Enter committee type"
              inputValue={member.committee_type || ""}
              setInputValue={(value) => handleInputChange(member.id, "committee_type", value)}
              className="committee-type-input"
            />

            <ImageUpload
              label="Upload Image"
              inputValue={member.image}
              setInputValue={(file) => handleInputChange(member.id, "image", file)}
              allowedExtensions={["jpg", "jpeg", "png"]}
              required={false}
            />

            <Select
              label="Country"
              options={
                Array.isArray(countriesList)
                  ? countriesList.map((country) => ({
                      value: country.name,
                      label: country.name,
                      flag_url: country.flag_url,
                    }))
                  : []
              }
              value={member.country || ""}
              onChange={(value) => handleInputChange(member.id, "country", value)}
            />
          </div>

          <Button className="delete-button-committee" onClick={() => deleteCommitteeMember(member)}>
            Delete
          </Button>
        </div>
      ))}
    </div>
  );
};

const EditConferencesAdmin = ({
  setIsOpen,
  getConference,
  setConference,
  conferenceData,
}) => {
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  // All states
  const [committeeMembers, setCommitteeMembers] = useState([]);
  const [deletedCommitteeIds, setDeletedCommitteeIds] = useState([]); // ✅ NEW

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [location, setLocation] = useState("");
  const [status, setStatus] = useState("upcoming");
  const [image, setImage] = useState(null);
  const [firstAnnouncement, setFirstAnnouncement] = useState(null);
  const [secondAnnouncement, setSecondAnnouncement] = useState(null);
  const [brochure, setBrochure] = useState(null);
  const [scientificProgram, setScientificProgram] = useState(null);
  const [companionDinnerPrice, setCompanionDinnerPrice] = useState("");
  const [logo, setLogo] = useState("");
  const [secondLogo, setSecondLogo] = useState("");
  const [visaPrice, setVisaPrice] = useState(0);
  const [country, setCountry] = useState("");
  const [entries, setEntries] = useState([]);
  const [topics, setTopics] = useState([]);

  // ✅ MAGIC FUNCTION: JSON STRING → Array of Objects
  const parseWhatsInclude = (whatsIncludeData) => {
    if (!whatsIncludeData) return [{ id: Date.now(), text: "" }];

    try {
      if (typeof whatsIncludeData === "string") {
        const parsed = JSON.parse(whatsIncludeData);
        if (Array.isArray(parsed)) {
          return parsed
            .map((text, index) => ({ id: Date.now() + index, text: text || "" }))
            .filter((item) => item.text && item.text.trim());
        }
        return [{ id: Date.now(), text: parsed || "" }];
      }

      if (Array.isArray(whatsIncludeData)) {
        return whatsIncludeData
          .map((text, index) => ({
            id: Date.now() + index,
            text: typeof text === "string" ? text : text?.text || text || "",
          }))
          .filter((item) => item.text && item.text.trim());
      }

      return [{ id: Date.now(), text: whatsIncludeData?.text || whatsIncludeData || "" }];
    } catch (error) {
      return [{ id: Date.now(), text: whatsIncludeData || "" }];
    }
  };

  // ✅ Backend format converter
  const convertPriceToObject = (data) => {
    let result = {};
    data.forEach((item, index) => {
      result[`prices[${index}][price_description]`] = item.description || "";
      result[`prices[${index}][price]`] = item.price || "";
      result[`prices[${index}][price_type]`] = item.price_type || "";

      if (Array.isArray(item.whats_include) && item.whats_include.length > 0) {
        item.whats_include.forEach((includeItem, includeIndex) => {
          result[`prices[${index}][whats_include][${includeIndex}]`] = includeItem.text || "";
        });
      }
    });
    return result;
  };

  // ✅ Load existing data
  useEffect(() => {
    if (!conferenceData) return;

    setTitle(conferenceData.title || "");
    setDescription(conferenceData.description || "");
    setStartDate(conferenceData.start_date ? conferenceData.start_date.split("T")[0] : "");
    setEndDate(conferenceData.end_date ? conferenceData.end_date.split("T")[0] : "");
    setLocation(conferenceData.location || "");
    setVisaPrice(conferenceData.visa_price || 0);
    setCompanionDinnerPrice(conferenceData.companion_dinner_price || "");
    setCountry(conferenceData.country || "");
    setLogo(conferenceData.logo || "");
    setSecondLogo(conferenceData.second_logo || "");
    setStatus(conferenceData.status || "upcoming");

    // ✅ Committee: keep backend_id separate
    const committee = Array.isArray(conferenceData.committee_members)
      ? conferenceData.committee_members.map((member, idx) => ({
          id: `local_${member.id || idx}_${Date.now()}`, // React key stable
          backend_id: member.id || null,                // real DB id
          name: member.name || "",
          title: member.title || "",
          committee_type: member.committee_type || "",
          country: member.country || "",
          conference_id: conferenceData.id,
          image: member.committee_image || null,        // URL string
        }))
      : [];
    setCommitteeMembers(committee);
    setDeletedCommitteeIds([]);

    // Topics
    const topicsData = Array.isArray(conferenceData.scientific_topics)
      ? conferenceData.scientific_topics.map((t) => t.title).filter(Boolean)
      : [];
    setTopics(topicsData.length ? topicsData : [""]);

    // Prices
    const pricesData = Array.isArray(conferenceData.prices) ? conferenceData.prices : [];
    const entriesData = pricesData.map((price, index) => ({
      id: Date.now() + index,
      price_type: price.price_type || "",
      price: price.price || "",
      description: price.description || price.price_description || "",
      whats_include: parseWhatsInclude(price.whats_include),
    }));

    setEntries(
      entriesData.length
        ? entriesData
        : [
            {
              id: Date.now(),
              price_type: "",
              price: "",
              description: "",
              whats_include: [{ id: Date.now() + 1, text: "" }],
            },
          ]
    );
  }, [conferenceData]);

  // Countries fetch
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const response = await axios.get("https://eventscons.com/eventbackendnew/api/countries", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCountries(response.data.data || []);
      } catch (error) {
        console.error("Countries fetch failed:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCountries();
  }, []);

  // Topics handlers
  const handleTopicChange = (index, newValue) => {
    const updated = [...topics];
    updated[index] = newValue;
    setTopics(updated);
  };
  const handleAddTopic = () => setTopics([...topics, ""]);
  const handleRemoveTopic = (index) => setTopics(topics.filter((_, i) => i !== index));

  const onDeleteExistingCommitteeId = (backendId) => {
    setDeletedCommitteeIds((prev) => [...prev, backendId]);
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const prices = convertPriceToObject(entries);
      const formData = new FormData();

      // Prices
      for (const key in prices) formData.append(key, prices[key]); // append adds new value [web:16]

      // Basic fields
      formData.append("title", title);
      formData.append("description", description);
      formData.append("start_date", startDate);
      formData.append("end_date", endDate);
      formData.append("location", location);
      formData.append("status", status);
      formData.append("visa_price", visaPrice);
      formData.append("companion_dinner_price", companionDinnerPrice);
      formData.append("country", country);
      formData.append("scientific_topics", topics.filter(Boolean).join(","));

      // Files
      if (image) formData.append("image", image);
      if (logo) formData.append("logo", logo);
      if (secondLogo) formData.append("second_logo", secondLogo);
      if (firstAnnouncement) formData.append("first_announcement_pdf", firstAnnouncement);
      if (secondAnnouncement) formData.append("second_announcement_pdf", secondAnnouncement);
      if (brochure) formData.append("conference_brochure_pdf", brochure);
      if (scientificProgram) formData.append("conference_scientific_program_pdf", scientificProgram);

      // ✅ Committee Members (append as nested fields)
      committeeMembers.forEach((m, index) => {
        formData.append(`committee_members[${index}][id]`, m.backend_id || "");
        formData.append(`committee_members[${index}][name]`, m.name || "");
        formData.append(`committee_members[${index}][title]`, m.title || "");
        formData.append(`committee_members[${index}][committee_type]`, m.committee_type || "");
        formData.append(`committee_members[${index}][country]`, m.country || "");
        formData.append(`committee_members[${index}][conference_id]`, conferenceData.id);

        // image only when NEW File selected
        if (m.image instanceof File) {
          formData.append(`committee_members[${index}][image]`, m.image);
        }
      });

      // ✅ Deleted ids
      formData.append("deleted_committee_ids", JSON.stringify(deletedCommitteeIds));

      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      await axios.post(`${BaseUrl}/conferences/${conferenceData.id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Conference updated successfully!");
      setIsOpen(false);
      getConference();
    } catch (error) {
      console.error("❌ Update failed:", error);
      toast.error("Update failed!");
    }
  };

  return (
    <Drawer
      anchor="right"
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: "100%", md: "50%" },
          padding: "24px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        },
      }}
      open={true} // ✅ FIXED (your current props don't include isOpen)
      onClose={() => setIsOpen(false)}
    >
      <div style={{ display: "flex", justifyContent: "flex-end", padding: 2 }}>
        <IconButton onClick={() => setIsOpen(false)}>
          <CloseRounded />
        </IconButton>
      </div>

      <Typography
        variant="h6"
        sx={{
          color: "#c62828",
          textAlign: "center",
          backgroundColor: "#f1f1f1",
          padding: 1,
          borderRadius: 1,
          marginBottom: 2,
        }}
      >
        Edit Conference
      </Typography>

      <Box sx={{ padding: 2, overflowY: "auto" }}>
        <Input label="Title" inputValue={title} setInputValue={setTitle} required />
        <TextArea label="Description" value={description} setValue={setDescription} />
        <DateInput label="Start Date" inputValue={startDate} setInputValue={setStartDate} />
        <DateInput label="End Date" inputValue={endDate} setInputValue={setEndDate} />
        <Input label="Location" inputValue={location} setInputValue={setLocation} required />

        <Input label="Visa Price (USD)" inputValue={visaPrice} setInputValue={setVisaPrice} type="number" />
        <Input
          label="Companion Dinner Price (USD)"
          inputValue={companionDinnerPrice}
          setInputValue={setCompanionDinnerPrice}
          type="number"
        />

        <ImageUpload
          label="Main Image"
          inputValue={image}
          setInputValue={setImage}
          existingFile={conferenceData?.image}
          allowedExtensions={["jpg", "jpeg", "png"]}
        />
        <ImageUpload
          label="Logo"
          inputValue={logo}
          setInputValue={setLogo}
          existingFile={conferenceData?.logo}
          allowedExtensions={["jpg", "jpeg", "png"]}
        />
        <ImageUpload
          label="Second Logo"
          inputValue={secondLogo}
          setInputValue={setSecondLogo}
          existingFile={conferenceData?.second_logo}
          allowedExtensions={["jpg", "jpeg", "png"]}
        />
        <ImageUpload
          label="First Announcement PDF"
          inputValue={firstAnnouncement}
          setInputValue={setFirstAnnouncement}
          existingFile={conferenceData?.first_announcement_pdf}
          allowedExtensions={["pdf"]}
        />
        <ImageUpload
          label="Second Announcement PDF"
          inputValue={secondAnnouncement}
          setInputValue={setSecondAnnouncement}
          existingFile={conferenceData?.second_announcement_pdf}
          allowedExtensions={["pdf"]}
        />
        <ImageUpload
          label="Conference Brochure PDF"
          inputValue={brochure}
          setInputValue={setBrochure}
          existingFile={conferenceData?.conference_brochure_pdf}
          allowedExtensions={["pdf"]}
        />
        <ImageUpload
          label="Scientific Program PDF"
          inputValue={scientificProgram}
          setInputValue={setScientificProgram}
          existingFile={conferenceData?.conference_scientific_program_pdf}
          allowedExtensions={["pdf"]}
        />

        {loading ? (
          <div>Loading countries...</div>
        ) : (
          <Select
            label="Country"
            options={countries.map((c) => ({
              value: c.name,
              label: c.name,
              flag_url: c.flag_url,
            }))}
            value={country}
            onChange={setCountry}
          />
        )}

        <div className="topics-container">
          <div className="topic-title">
            Topics <span className="star">*</span>
          </div>

          <div className="topics-container-inputs">
            {topics.map((topic, index) => (
              <div key={index} className="topic-input-container">
                <Input
                  placeholder="Enter a topic"
                  inputValue={topic}
                  setInputValue={(val) => handleTopicChange(index, val)}
                />
                {topics.length > 1 && (
                  <SVG className="delete-icon" src={deleteIcon} onClick={() => handleRemoveTopic(index)} />
                )}
              </div>
            ))}
            <div className="add-topic-btn-container">
              <Button type="button" onClick={handleAddTopic} className="add-topic-btn">
                Add Topic
              </Button>
            </div>
          </div>
        </div>

        <PriceForm entries={entries} setEntries={setEntries} />

        <CommitteeForm
          committeeMembers={committeeMembers}
          setCommitteeMembers={setCommitteeMembers}
          countriesList={countries}
          onDeleteExistingId={onDeleteExistingCommitteeId}
        />

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#c62828",
            marginTop: "20px",
            color: "#fff",
            width: "100%",
            height: 50,
            fontSize: "16px",
            "&:hover": { backgroundColor: "#e63946", color: "#fff" },
          }}
          onClick={handleSubmit}
        >
          Update Conference
        </Button>
      </Box>
    </Drawer>
  );
};

export default EditConferencesAdmin;
